import React, { useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import { IndustryFaqData } from '../data/IndustryFaqData';
import { Marker } from 'react-mark.js';

function IndustryFAQ({ searchTerm, searchBool }) {

    const [IFCAcc, setIFCAcc] = useState({ isVisible: true, isOpen: false });
    const [IECAcc, setIECAcc] = useState({ isVisible: true, isOpen: false });
    const [IEAcc, setIEAcc] = useState({ isVisible: true, isOpen: false });

    useEffect(() => {
        if (IndustryFaqData[0].IndustryFoundationCertification.filter((item) => item.Question.toLowerCase().includes(searchTerm.toLowerCase()) || item.Answer.toLowerCase().includes(searchTerm.toLowerCase())).length == 0) {
            setIFCAcc({ ...IFCAcc, isVisible: false })
        } else
            setIFCAcc({ ...IFCAcc, isVisible: true, isOpen: true })

        if (IndustryFaqData[0].IndustryExternalCertifications.filter((item) => item.Question.toLowerCase().includes(searchTerm.toLowerCase()) || item.Answer.toLowerCase().includes(searchTerm.toLowerCase())).length == 0) {
            setIECAcc({ ...IECAcc, isVisible: false })
        } else
            setIECAcc({ ...IECAcc, isVisible: true, isOpen: true })

        if (IndustryFaqData[0].IndustryExperts.filter((item) => item.Question.toLowerCase().includes(searchTerm.toLowerCase()) || item.Answer.toLowerCase().includes(searchTerm.toLowerCase())).length == 0) {
            setIEAcc({ ...IEAcc, isVisible: false })
        } else
            setIEAcc({ ...IEAcc, isVisible: true, isOpen: true })

        if (searchTerm == "") {
            setIFCAcc({ ...IFCAcc, isVisible: true, isOpen: false })
            setIECAcc({ ...IECAcc, isVisible: true, isOpen: false })
            setIEAcc({ ...IEAcc, isVisible: true, isOpen: false })
        }


    }, [searchTerm, searchBool])



    return (
        <>
            <div className="genai-container">
                <Accordion defaultExpanded className={IFCAcc.isVisible == false ? "hide-accordion" : null}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        Industry Foundation Certification
                    </AccordionSummary>
                    <AccordionDetails>
                        {IndustryFaqData[0].IndustryFoundationCertification
                            .filter((item) => item.Question.toLowerCase().includes(searchTerm.toLowerCase()) || item.Answer.toLowerCase().includes(searchTerm.toLowerCase()))
                            .map((item) => {
                                return (
                                    <div className='ques-ans'>
                                        <div className="ques-content">
                                            <span>Q. </span>
                                            <Marker mark={searchTerm}>
                                                {item.Question}
                                            </Marker>
                                        </div>
                                        <div className="ans-content">
                                            <span>A. </span>
                                            <Marker mark={searchTerm}>
                                                <p dangerouslySetInnerHTML={{ __html: item.Answer }}>
                                                </p>
                                            </Marker>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    expanded={IECAcc.isOpen == true ? true : false}
                    onClick={() => setIECAcc({ ...IECAcc, isOpen: !IECAcc.isOpen })}
                    className={IECAcc.isVisible == false ? "hide-accordion" : null}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        Industry External Certifications
                    </AccordionSummary>
                    <AccordionDetails>
                        {IndustryFaqData[0].IndustryExternalCertifications
                            .filter((item) => item.Question.toLowerCase().includes(searchTerm.toLowerCase()) || item.Answer.toLowerCase().includes(searchTerm.toLowerCase()))
                            .map((item) => {
                                return (
                                    <div className='ques-ans'>
                                        <div className="ques-content">
                                            <span>Q. </span>
                                            <Marker mark={searchTerm}>
                                                {item.Question}
                                            </Marker>
                                        </div>
                                        <div className="ans-content">
                                            <span>A. </span>
                                            <Marker mark={searchTerm}>
                                                <p dangerouslySetInnerHTML={{ __html: item.Answer }}>
                                                </p>
                                            </Marker>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    expanded={IEAcc.isOpen == true ? true : false}
                    onClick={() => setIEAcc({ ...IEAcc, isOpen: !IEAcc.isOpen })}
                    className={IEAcc.isVisible == false ? "hide-accordion" : null}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"

                    >
                        Industry Experts
                    </AccordionSummary>
                    <AccordionDetails>
                        {IndustryFaqData[0].IndustryExperts
                            .filter((item) => item.Question.toLowerCase().includes(searchTerm.toLowerCase()) || item.Answer.toLowerCase().includes(searchTerm.toLowerCase()))
                            .map((item) => {
                                return (
                                    <div className='ques-ans'>
                                        <div className="ques-content">
                                            <span>Q. </span>
                                            <Marker mark={searchTerm}>
                                                {item.Question}
                                            </Marker>
                                        </div>
                                        <div className="ans-content">
                                            <span>A. </span>
                                            <Marker mark={searchTerm}>
                                                <p dangerouslySetInnerHTML={{ __html: item.Answer }}>
                                                </p>
                                            </Marker>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </AccordionDetails>
                </Accordion>
            </div>
        </>
    )
}

export default IndustryFAQ;